import React, { useState } from "react";

const TokensVested = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeClass = (index) => {
    if (index === activeIndex) {
      return "bg-main-black";
    }
    return "bg-dark-gray";
  };
  return (
    <div className="">
      <div className="flex text-[10px] sm:text-res-xxs font-semibold">
        <button
          onClick={() => setActiveIndex(0)}
          className={`${activeClass(
            0
          )} w-full xl:w-[184px] h-[38px] flex justify-center items-center rounded-t-[16px]`}
        >
          <p className="font-semibold text-res-xxs">Tokens vested</p>
        </button>
      </div>
      <div className="bg-main-black pt-[8px] pb-[7px] px-[24px] rounded-b-[16px]">
        <div className="text-res-xs font-semibold leading-[22px] flex flex-col sm:flex-row gap-[31px]">
          <div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">Drip</span>
              <span className=" ml-[31px] mr-[15px]">17,392</span>
              <span className=" font-normal  mr-[15px]">$3,738.49</span>
            </div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">BR34P</span>
              <span className=" ml-[16px] mr-[19px]">4,284</span>
              <span className=" font-normal   mr-[15px]">$2,764.96</span>
            </div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">Drip</span>
              <span className=" ml-[31px] mr-[23px]">1,209</span>
              <span className=" font-normal  mr-[15px]">$2,764.96</span>
            </div>
          </div>
          <div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">Drip</span>
              <span className=" ml-[31px] mr-[15px]">17,392</span>
              <span className=" font-normal  mr-[15px]">$3,738.49</span>
            </div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">BR34P</span>
              <span className=" ml-[16px] mr-[19px]">4,284</span>
              <span className=" font-normal   mr-[15px]">$2,764.96</span>
            </div>
            <div className="flex items-center pb-[5px]">
              <div className="w-[8px] mr-[8px] h-[8px] bg-main-green rounded-full"></div>
              <span className="text-main-green">Drip</span>
              <span className=" ml-[31px] mr-[23px]">1,209</span>
              <span className=" font-normal  mr-[15px]">$2,764.96</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TokensVested;
